"use strict";
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProjectBasemapStyleUrl = isProjectBasemapStyleUrl;
function isProjectBasemapStyleUrl(layer) {
    return 'styleUrl' in layer && typeof layer.styleUrl === 'string';
}
//# sourceMappingURL=mapBaseLayersProject.types.js.map